import { render, staticRenderFns } from "./FileSlider.vue?vue&type=template&id=3042541d&scoped=true&"
import script from "./FileSlider.vue?vue&type=script&lang=js&"
export * from "./FileSlider.vue?vue&type=script&lang=js&"
import style0 from "./FileSlider.vue?vue&type=style&index=0&id=3042541d&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3042541d",
  null
  
)

export default component.exports